import List from '@/components/list/List';
import classNames from 'classnames';
import React from 'react';
import text from '../../../text';
import { usePaymentContext } from '@/mp/hooks/usePaymentContext';
import { useAppSelector } from '@/hooks/useAppSelector';
import { orderV2Selectors } from '@/redux/selectors/order.v2';

const GrandTotal: React.FC<{ isApproximate?: boolean }> = ({
  isApproximate = false,
}) => {
  const { jobId, formatPrice, asMember } = usePaymentContext();
  const quote = useAppSelector((state) =>
    orderV2Selectors.getQuote(state, jobId, asMember)
  );

  return (
    <List isPaddingless className='InvoiceTotal no-border-top mt-0 pt-0'>
      {/* @ts-expect-error List.Item is not typed */}
      <List.Item
        className={classNames(
          'font-grey--3 font-weight--400-important no-border-bottom'
        )}
        key='invoice-subtotal'
        description={text('subtotal')}
        value={
          quote?.totals.totalGross === 'TBC'
            ? text('toBeConfirmed')
            : `${isApproximate ? '~' : ''}${formatPrice(quote?.totals.totalGross ?? 0)}`
        }
      />
      {/* @ts-expect-error List.Item is not typed */}
      <List.Item
        className={classNames(
          'invoice-totals font-grey--3 font-weight--400-important'
        )}
        key='invoice-gst'
        description={text('gst')}
        value={
          quote?.totals.taxesTotal === 'TBC'
            ? text('toBeConfirmed')
            : `${isApproximate ? '~' : ''}${formatPrice(quote?.totals.taxesTotal ?? 0)}`
        }
      />
      {/* @ts-expect-error List.Item is not typed */}
      <List.Item
        className={classNames('invoice-totals font-grey--3')}
        key='invoice-total'
        description={text('total')}
        value={
          quote?.totals.totalNet === 'TBC'
            ? text('toBeConfirmed')
            : `${isApproximate ? '~' : ''}${formatPrice(quote?.totals.totalNet ?? 0)}`
        }
      />
    </List>
  );
};

export default GrandTotal;
